export default "__VITE_ASSET__8af3ad67__"